import { Redirect } from "react-router-dom";

import { AFFILIATE, PRACTITIONER } from "@/core/constants";
import { CMP_AFFILIATE_URL, CMP_PRACTITIONER_URL, PARTNERS_EXTERNAL_URL } from "@/core/urls";

import { useAuthContext } from "./AuthProvider";

function PartnersMarketingRedirect({ children }) {
  const { user } = useAuthContext();

  if (user) {
    if (user.practitionerProfile) {
      if (user.practitionerProfile.tier === AFFILIATE) {
        return <Redirect to={CMP_AFFILIATE_URL} />;
      } else if (user.practitionerProfile.tier === PRACTITIONER) {
        return <Redirect to={CMP_PRACTITIONER_URL} />;
      } else {
        window.location.href = PARTNERS_EXTERNAL_URL;
        return null;
      }
    } else {
      window.location.href = PARTNERS_EXTERNAL_URL;
      return null;
    }
  } else {
    window.location.href = PARTNERS_EXTERNAL_URL;
    return null;
  }
}

export default PartnersMarketingRedirect;
